
import React, { useState, useRef, useEffect,useContext } from 'react';
import { convertFromRaw, EditorState } from 'draft-js';
import { Box, Grid, useMediaQuery, Link as MuiLink, Typography, Button,Avatar, Card,CardContent, CardMedia, Checkbox, List, ListItem, Divider, Snackbar, Alert, Rating } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LuAlarmClock } from "react-icons/lu";
import { RiRestaurantFill } from "react-icons/ri";
import { PiCookingPotFill } from "react-icons/pi";
import { FaFlag, FaFolder, FaInstagram } from "react-icons/fa";
import InstagramIcon from '@mui/icons-material/Instagram';
export default function Recipe({postData}) {
    const [unit, setUnit] = useState('metric');
    const [scale, setScale] = useState(1);
    const [checkedItems, setCheckedItems] = useState([]);
    let imageSrc = '';
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    // Check if postData.files is present and if it is an instance of File
    if (postData.files && postData.files.length > 0) {
      // Use createObjectURL for previewing the image
      imageSrc = URL.createObjectURL(postData.files[0]);
    } else if (postData.cover) {
      // Use the URL for the image fetched from the server
      imageSrc = postData.cover;
    }

    
      // Handle unit switch
  const handleUnitSwitch = (newUnit) => {
    setUnit(newUnit);
  };

  // Handle ingredient scale
  const handleScale = (newScale) => {
    setScale(newScale);
  };
  const unitConversions = {
    grams: { to: 'oz', factor: 0.035274 },
    oz: { to: 'grams', factor: 28.3495 },
    kg: { to: 'lb', factor: 2.20462 },
    lb: { to: 'kg', factor: 0.453592 },
  };

  const handleCheck = (index) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = !updatedCheckedItems[index];
    setCheckedItems(updatedCheckedItems);
  };

  const convertUnit = (amount, unit, toUnit) => {
    if (!amount || !unitConversions[unit]) return amount; // If no amount or no conversion available, return original amount
    const conversionFactor = unitConversions[unit].factor;
    return toUnit === unitConversions[unit].to
      ? (amount * conversionFactor).toFixed(2) // Convert to the target unit
      : (amount / conversionFactor).toFixed(2); // Convert back to the original unit
  };

    const unitAndScaleSM = '0.6rem';
     const unitAndScaleXS = '0.5rem';
    const scaleBtnSM = '0.4rem';
    const scaleBtnMd = '1rem';
  const scaleBtnXS = '0.6rem';
  const sectionTitleSM = '1rem';
   const sectionTitleXS = '0.8rem';
   const sectionTitleMD = '1.4rem';
   

  useEffect(() => {


    // Initialize checkbox states based on ingredients
    if (postData && postData.ingredients) {
      setCheckedItems(Array(postData.ingredients.length).fill(false));
    }
  }, [postData]);

  // Clean up the object URL on component unmount
  useEffect(() => {
    let objectUrl;
    if (postData.files && postData.files.length > 0) {
      objectUrl = imageSrc; // Use the previously created object URL
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl); // Clean up the URL
      }
    };
  }, [imageSrc]);

  const formatAmount = (amount) => {
    // Parse the amount as a float
    const num = parseFloat(amount);
    // Check if the number is an integer
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
  };


  return (
    <Grid
            container
            bgcolor="#ca7735"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
               
                alignItems: 'center',  // Center items horizontally
             
                marginY: {
                    xs: '4rem', // Space between rows for mobile
                    sm: '4rem',    // No extra space for larger screens
                    md: '4rem'
                  },
                 
            }}
            >
            <Box
                sx={{
                width: '150px',  // Set width and height for the image container
                height: '150px',
                overflow: 'hidden',  // Ensures the image stays within the circle
                borderRadius: '50%',  // Makes the container circular
                marginTop: '-4rem',   // Adjust margin if needed to make the image overlap
                border: '4px solid white'  // Optional: adds a white border around the image
                }}
            >
                <img
                    alt={postData.title}
                    src={imageSrc} // Use the determined image source
                    style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    }}
                />
            </Box>



            <Typography variant="h3" gutterBottom className='sub-heading' textAlign="center" sx={{ fontSize: isSmallScreen ? '1.2rem' : '1.5rem'}}>
                {postData.title}
            </Typography>

            <Divider sx={{ marginTop: '1rem', color: 'white' }} />

            <Grid
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{ marginBottom: '1rem' }}
            >
                <Rating value={4.5} precision={0.5} readOnly sx={{ fontSize: isSmallScreen ? '0.6rem' : '1.2rem'}}/>
                <Typography variant="body1" sx={{ marginLeft: '0.5rem',fontSize: isSmallScreen ? '0.6rem' : '1.2rem' }}>(4.5/5 from 30 reviews)</Typography>
            </Grid>


       <></>

          <Grid
          container
          columnGap={3}
           display="flex" 
           alignItems="center"
           justifyContent="center" 
          >

          <Box display="flex" alignItems="center" justifyContent="center" >

          <LuAlarmClock />  <Typography variant="body1" sx={{ marginLeft: '0.5rem', fontSize: isSmallScreen ? '0.6rem' : '1.2rem' }}>TOTAL TIME: <span>{ parseInt( postData.additionalInfo.prepTime ) + parseInt( postData.additionalInfo.cookTime ) }</span> Minutes</Typography>

          </Box>

          <Box display="flex" alignItems="center">

          <RiRestaurantFill />  <Typography variant="body1" sx={{ marginLeft: '0.5rem', fontSize: isSmallScreen ? '0.6rem' : '1.2rem' }}>YIELD: <span>{postData.additionalInfo.serving * scale} </span>servings </Typography>

          </Box>
          </Grid>


          
          

          
                    <Grid sx={{ paddingX: {
                    xs: '0.2rem', // Space between rows for mobile
                    sm: '0.4rem',    // No extra space for larger screens
                    md: '0.5rem',    
                }, maxWidth: '95%'}} >
            <Grid
            container
            sx={{
                backgroundColor: 'white',
                color: 'black',
                display: 'flex',
                flexDirection: 'column',
                padding: {
                    xs :'0.8rem 0.5rem',
                    sm :'0.8rem 0.5rem',
                    md :'1rem 2rem',
                }
            }}
            >

           
                <Box
            
                >
                <Typography variant="h6" color="textSecondary" gutterBottom sx={{ fontSize: {md:sectionTitleSM,  sm : sectionTitleXS, xs: sectionTitleXS}}}>
            {postData.summary}
          </Typography> 
                </Box>

                <Divider sx={{ marginTop: '1rem', color: 'gray' }} />

        
   {/* Key Ingredients Section */}
   {postData.ingredients && postData.ingredients.length > 0 && (
        <Box
        //  ref={sectionRefs.current[0]} 
          >




            <Grid container mt={5}>
 

            {/* Unit and Scale Controls */}
            <Grid
                container
                md={12}
                sm={12}
                sx={{
                marginBottom: '1rem',
                display: 'flex',
                flexDirection: {
                    xs: 'column', // Stack for mobile
                    sm: 'row', // Row layout for tablets and up
                },
                alignItems: {
                    md:'flex-end',
                    xs: 'start',
                    sm: 'start',
                },
                justifyContent: {
                    md:'flex-end',
                    xs: 'start',
                    sm: 'start',
                },
                
                }}
            >
                {/* Unit Switcher */}
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                alignItems: 'center',
                    marginBottom: {
                    xs: '1rem', // Space between rows for mobile
                    sm: '0',    // No extra space for larger screens
                    },
                }}
                >
                <Typography
                    variant="body2"
                    className="me-3 recipe-text"
                    sx={{
                    fontSize: {
                        xs: unitAndScaleXS, // Larger font for mobile readability
                        sm: unitAndScaleSM, // Smaller font for tablets
                        md: '0.7rem', // Smallest font for larger screens
                    },
                    }}
                >
                    UNITS
                </Typography>

                <Button
                    className={unit === 'us' ? 'unit-btn active' : 'unit-btn'}
                    onClick={() => handleUnitSwitch('us')}
                    sx={{
                        fontSize: {
                            md: scaleBtnMd,
                            xs: scaleBtnXS, // Larger font for mobile readability
                            sm: scaleBtnSM, // Smaller font for tablets
                        
                        },
                    }}
                >
                    US
                </Button>
                <Button
                    className={unit === 'metric' ? 'unit-btn active' : 'unit-btn'}
                    onClick={() => handleUnitSwitch('metric')}
                    sx={{
                    marginLeft: {
                        xs: scaleBtnXS, // Larger font for mobile readability
                        sm: scaleBtnSM, // Smaller font for tablets
                    },
                    fontSize: {
                        md: scaleBtnMd,
                        xs: scaleBtnXS, // Larger font for mobile readability
                        sm: scaleBtnSM, // Smaller font for tablets
                    
                    },
                    }}
                >
                    Metric
                </Button>
                </Box>

                {/* Scale Switcher */}
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: {
                    xs: '0',      // No margin for mobile
                    sm: '1rem',   // Standard margin for larger screens
                    },
                }}
                >
                <Typography
                    variant="body2"
                    className="me-3 recipe-text"
                    sx={{
                        fontSize: {
                            md: scaleBtnMd,
                            xs: scaleBtnXS, // Larger font for mobile readability
                            sm: scaleBtnSM, // Smaller font for tablets
                        
                        },
                    }}
                >
                    SCALE
                </Typography>

                <Button
                    className={scale === 0.5 ? 'unit-btn active' : 'unit-btn'}
                    onClick={() => handleScale(0.5)}
                    sx={{
                        fontSize: {
                            md: scaleBtnMd,
                            xs: scaleBtnXS, // Larger font for mobile readability
                            sm: scaleBtnSM, // Smaller font for tablets
                        
                        },
                    }}
                >
                    1/2X
                </Button>
                <Button
                    className={scale === 1 ? 'unit-btn active' : 'unit-btn'}
                    onClick={() => handleScale(1)}
                    sx={{
                    marginLeft: {
                        xs: '0.5rem',
                        sm: '1rem',
                    },
                    fontSize: {
                        md: scaleBtnMd,
                        xs: scaleBtnXS, // Larger font for mobile readability
                        sm: scaleBtnSM, // Smaller font for tablets
                    
                    },
                    }}
                >
                    1X
                </Button>
                <Button
                    className={scale === 2 ? 'unit-btn active' : 'unit-btn'}
                    onClick={() => handleScale(2)}
                    sx={{
                    marginLeft: {
                        xs: '0.5rem',
                        sm: '1rem',
                    },
                    fontSize: {
                        md: scaleBtnMd,
                        xs: scaleBtnXS, // Larger font for mobile readability
                        sm: scaleBtnSM, // Smaller font for tablets
                    
                    },
                    }}
                >
                    2X
                </Button>
                </Box>
            </Grid>

            {/* Ingredients Section */}
            <Grid container md={12} sm={12}>
                
                <Typography
                variant="h6"
                gutterBottom
                className="recipe-section"
                sx={{
                    fontSize: {
                    xs: '1rem', // Small font size for mobile
                    sm: '1.1rem', // Slightly larger for tablets
                    md: '1.6rem', // Default for medium and large screens
                    },
                }}
                >
                Ingredients
                </Typography>
            </Grid>
                </Grid>

          <List>
  {postData.ingredients.map((ingredient, index) => {
    let adjustedAmount = ingredient.amount;
    let adjustedUnit = ingredient.unit;

    // Check if both amount and unit are provided
    if (!adjustedAmount || !adjustedUnit) {
      return (
        <ListItem key={index}>
              <Checkbox
          checked={checkedItems[index]}
          onChange={() => handleCheck(index)}
          color="primary"
          sx={{
            '&.Mui-checked' :{
                color: '#f9eae1'
            }
          }}
        />
          <Typography variant="body1" className='recipe-text-dark' style={{
            textDecoration: checkedItems[index] ? 'line-through' : 'none',
            textTransform:'capitalize'
          }}>
            {ingredient.name} 
          </Typography>
        </ListItem>
      );
    }

    // Convert grams to oz or kg to lb when switching to US units
    if (unit === 'us') {
      if (adjustedUnit === 'grams') {
        adjustedAmount = convertUnit(adjustedAmount, 'grams', 'oz');
        adjustedUnit = 'oz'; // Update unit to oz
      } else if (adjustedUnit === 'kg') {
        adjustedAmount = convertUnit(adjustedAmount, 'kg', 'lb');
        adjustedUnit = 'lb'; // Update unit to lb
      }
    }

    // Convert oz to grams or lb to kg when switching to Metric units
    if (unit === 'metric') {
      if (adjustedUnit === 'oz') {
        adjustedAmount = convertUnit(adjustedAmount, 'oz', 'grams');
        adjustedUnit = 'grams'; // Update unit to grams
      } else if (adjustedUnit === 'lb') {
        adjustedAmount = convertUnit(adjustedAmount, 'lb', 'kg');
        adjustedUnit = 'kg'; // Update unit to kg
      }
    }

    // Scale the adjusted ingredient amount
    const scaledAmount = formatAmount((adjustedAmount * scale).toFixed(2)); // Apply scaling to the adjusted amount
    
    return (
        <ListItem key={index}>
        <Checkbox
          checked={checkedItems[index]}
          onChange={() => handleCheck(index)}
          color="primary"
          sx={{
            '&.Mui-checked' :{
                color: '#f9eae1'
            }
          }}
        />
        <Typography
          variant="body1"
          className='recipe-text-dark'
          style={{
            textDecoration: checkedItems[index] ? 'line-through' : 'none'
          }}
        >
          <span className='recipe-text '>
            {scaledAmount ? `${scaledAmount} ${adjustedUnit}` : ''}
          </span> {'  '}
          {ingredient.name}
        </Typography>
      </ListItem>
    );
  })}
</List>


          <Divider sx={{ marginY: '2rem' }} />
        </Box>
      )}


    
          {/* Instructions Section */}
          {postData.instructions && postData.instructions.length > 0 && (
            <Box mb={4} 
            // ref={sectionRefs.current[1]}
            >
              <Typography variant="h6" gutterBottom  className='recipe-section'   sx={{
        fontSize: {
          xs: sectionTitleXS, // Small font size for mobile
          sm: sectionTitleSM, // Slightly larger for tablets
          md: sectionTitleMD // Default for medium and large screens
        },
      }}>
                Instructions
              </Typography>

              <List
               
              >
                {postData.instructions.map((instruction, index) => (
                  <ListItem  key={index} sx={{textTransform:'capitalize'}}>
                       <span className='orange-circle'>{index + 1}  </span>   {instruction}
                  </ListItem>
                ))}
              </List>

              <Divider sx={{ marginY: '2rem' }} />
            </Box>
          )}


         
          </Grid>

          <Box bgcolor="#f2f2f2" py={4} px={3} my={3}>

            

            {/* notes Section */}
            {postData.notes && postData.notes.length > 0 && (
            <Box mb={4} 
            // ref={sectionRefs.current[1]}
             >
            <Typography variant="h6" gutterBottom  className='recipe-section '   sx={{
        fontSize: {
            xs: sectionTitleXS, // Small font size for mobile
            sm: sectionTitleSM, // Slightly larger for tablets
            md: sectionTitleMD // Default for medium and large screens
          },
      }}>
                Notes
            </Typography>

            <List>
                {postData.notes.map((note, index) => (
                <ListItem key={index} className='bg-white py-3 my-2'>
                    <Typography variant="body1" className='recipe-text-dark' sx={{textTransform:'capitalize'}}>
                    <span   className='orange-circle' >i</span> {note}
                    </Typography>
                </ListItem>
                ))}
            </List>

            <Divider sx={{ marginY: '2rem' }} />
            </Box>
            )}

            {/* Additional Information Section */}
            <Grid container spacing={2}  sx={{  }}
            // ref={sectionRefs.current[2]}
             color="black" className='px-1 d-flex justify-content-center'>
            <Grid item xs={6} >
            <Typography 
            
                variant="body1" 
                gutterBottom 
                sx={{
                 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',  // Centers the content horizontally
                gap: '8px',  // Adds space between the icon and text
                textAlign: 'center'  // Centers the text itself
                }}
            >
                <LuAlarmClock /> {/* Icon */}
                <strong>Prep Time:</strong> {/* Bold text */}
                {postData.additionalInfo.prepTime} minutes {/* Time info */}
            </Typography>
            </Grid>

            <Grid item xs={6}>
            <Typography 
                variant="body1" 
                gutterBottom 
                sx={{
                  
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',  // Centers the content horizontally
                gap: '8px',  // Adds space between the icon and text
                textAlign: 'center'  // Centers the text itself
                }}
            >
            <LuAlarmClock />     <strong>Cook Time:</strong> {postData.additionalInfo.cookTime} minutes
            </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography 
                variant="body1" 
                gutterBottom 
                sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',  // Centers the content horizontally
                gap: '8px',  // Adds space between the icon and text
                textAlign: 'center',  // Centers the text itself
                textTransform: 'capitalize'
                }}
            >
            <FaFolder />   <strong>Category:</strong> {postData.category}
            </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography 
                variant="body1" 
                gutterBottom 
                sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',  // Centers the content horizontally
                gap: '8px',  // Adds space between the icon and text
                textAlign: 'center',  // Centers the text itself
                textTransform: 'capitalize'
                }}
            >
            <PiCookingPotFill />  <strong>Method:</strong> {postData.additionalInfo.method}
            </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography 
                variant="body1" 
                gutterBottom 
                sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',  // Centers the content horizontally
                gap: '8px',  // Adds space between the icon and text
                textAlign: 'center',  // Centers the text itself
                textTransform: 'capitalize'
                }}
            >
            <FaFlag />     <strong>Cuisine:</strong> {postData.additionalInfo.cuisine}
            </Typography>
            </Grid>
            </Grid>
            </Box>
                    </Grid >


            <Grid container my={4} columnGap={2}paddingX="2rem">
                <Grid item md={1} sm={1} xs={1} display="flex"  >
                <InstagramIcon className='icon-recipe' 
                 sx={{
                  fontSize: {
                  xs: '1.5rem', // Small font size for mobile
                  sm: '2rem', // Slightly larger for tablets
                  md: '4rem', // Default for medium and large screens
                  },
              }}
         
                
                />
                </Grid>
                <Grid item md={10} sm={10} xs={10} display="flex" flexDirection="column" justifyContent="center" >
                    <Typography variant='h6' gutterBottom textTransform="uppercase" textAlign="start" className='recipe-text' color='white' sx={{fontSize: {md:sectionTitleMD, sm:sectionTitleSM, xs:sectionTitleXS}}} fontWeight="700">Did you make this recipe?</Typography>
                    <Typography 
                variant="body1" 
                gutterBottom 
                sx={{
                display: 'flex',
                  flexWrap: 'wrap',
                gap: '8px',  // Adds space between the icon and text
                    
                textAlign: 'start',  // Centers the text itself
                textTransform: 'capitalize',
                color: 'white',
               fontSize: isSmallScreen ? '0.6rem' : '1rem' 
                }}
                className='recipe-text'

                

            >
                Tag <Link  style={{color: 'white'}}>@chef.adel.aljaadi</Link>   on Instagram so we can admire your masterpiece! 🌟
                 </Typography>
                </Grid>
            </Grid>
          </Grid>
  )
}
